/* tslint:disable */

declare var Object: any;
export interface AggregatesInterface {
  CallObject?: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
}

export class Aggregates implements AggregatesInterface {
  CallObject: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  constructor(data?: AggregatesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Aggregates`.
   */
  public static getModelName() {
    return "Aggregates";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Aggregates for dynamic purposes.
  **/
  public static factory(data: AggregatesInterface): Aggregates{
    return new Aggregates(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Aggregates',
      plural: 'aggregates',
      properties: {
        CallObject: {
          name: 'CallObject',
          type: 'string'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Aggregates.ts